// extracted by mini-css-extract-plugin
module.exports = {"page":"B_page__z_uqX"};